import { createRouter, createWebHashHistory } from "vue-router";
import HomeView from "../views/home/index.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/details",
    name: "Details",
    component: import("../views/details/index.vue"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
